import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'y42-chat-resolve-button',
  templateUrl: './chat-resolve-button.component.html',
  styleUrls: ['./chat-resolve-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatResolveButtonComponent {
  @Input() tooltip = '';

  @Output() resolved = new EventEmitter<void>();

  onResolveClick() {
    this.resolved.emit();
  }
}
